import {MODAL_TYPE, showModal} from '../../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {NovaAgentVersionEntry} from './NovaVersionHistoryModal';

export interface NovaVersionHistoryModalPayload {
	versions: NovaAgentVersionEntry[];
	onRestore: (versionNumber: number) => Promise<void>;
}

export const showNovaVersionHistoryModal = (props: NovaVersionHistoryModalPayload): void => {
	showModal({type: MODAL_TYPE.NOVA_VERSION_HISTORY, ...props});
};
